module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Regular.d7a0dc42.woff2";